import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, notification, Modal, Drawer, Space, Button } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faCloudDownload,
  faEllipsis,
  faEye,
  faFilter,
  faInfoCircle,
  faThumbsDown,
  faThumbsUp,
  faTrash,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

import TobNavBar from "../../DashBaord/Top_navbar";

import moment from "moment";
import SkeltonList from "../../../components/SkeltonEffect/list";
import {
  list,
  details,
  sendNotification,
  changeReadStatus,
  changeStatus,
  deleteNotification,
} from "../../../controllers/V1/notificationController";
import { getPage, formatProjectDate } from "../../../controllers/common";

import { usePermissions } from "../../../controllers/PermissionContext";
import LoadingEffect from "../../../components/Loading/LoadingEffect";
import UserSelectWithSearch from "../../../components/UserSelectWithSearch";
import AgentSelectWithSearch from "../../../components/AgentSelectWithSearch";
import AdminSelectWithSearch from "../../../components/AdminSelectWithSearch";
import { Link } from "react-router-dom";
import NotificationDetails from "./NotificationDetails";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function BasicTabs() {
  const [showAddNotification, setShowAddNotification] = useState(false);
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () =>  setFilterShow(!isFilterShow); 
  const PERMISSION = usePermissions("notification");
  /************************************************************************************* */
  const [isLoading, setIsLoading] = useState(false);
  const targetRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  
  const [filter, setFilter] = useState({
    // from_date: moment().startOf("day").format("YYYY-MM-DD HH:mm"),
    // to_date: moment().endOf("day").format("YYYY-MM-DD HH:mm"),
    user_id: "",
  });
  const formRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [usersList, setUsersList] = useState([]);
  const [userType, setUserType] = useState("Users");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const messageRef = useRef(null);

  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...((filter?.from && filter?.to) && {
              createdAt: {
                $gte: `${filter?.from} :00:00:00`,
                $lte: `${filter?.to} :23:59:59`,
              },
            }),
          ...((filter?.filter_by && filter?.search) && { [filter?.filter_by] : filter?.search })
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count));
        } else {
          setListData([]);
          setTotalPages(getPage(1));
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };
  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
    document.title = "U-Winn CRM || Notifications List";
  }, [currentPage, filter]);
  // Close emoji picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showEmojiPicker &&
        messageRef.current &&
        !messageRef.current.parentElement.contains(event.target)
      ) {
        setShowEmojiPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showEmojiPicker]);

  const emojis = [
    "😊",
    "😂",
    "🥰",
    "😍",
    "🤗",
    "👍",
    "👏",
    "🙏",
    "💪",
    "✨",
    "🎉",
    "🎊",
    "❤️",
    "💯",
    "🔥",
    "⭐",
    "✅",
    "👌",
    "🤝",
    "💼",
    "📈",
    "📊",
    "💰",
    "🎯",
    "⚡",
    "🌟",
    "💡",
    "🚀",
  ];

  const handleEmojiClick = (emoji) => {
    const textarea = messageRef.current;
    if (textarea) {
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const text = textarea.value;
      const before = text.substring(0, start);
      const after = text.substring(end, text.length);
      textarea.value = before + emoji + after;
      textarea.selectionStart = textarea.selectionEnd = start + emoji.length;
      textarea.focus();
    }
  };

  const toggleAddNotification = () => {
    if(showAddNotification === true){
      setUsersList([])
      setUserType("Users");
    }
    setShowAddNotification(!showAddNotification);
  };

  const handleUserTypeChange = (e) => {
    const newUserType = e.target.value;
    setUserType(newUserType);
    setUsersList([]); // Clear selected users when switching type
  };

  const handleSendNotification = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);
      const res = await sendNotification({
        title: formData.get("title"),
        description: formData.get("message"),
        userType : userType,
        users_list: usersList || [],
      });
      if (res?.status === true) {
        notification.open({
          message: "Success",
          description: `Notification sent successfully.`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />
          ),
          duration: 2,
        });
      }
    } catch (error) {
      setIsLoading(false);
      console.log("error : ", error);
    } finally {
      setIsLoading(false);
      toggleAddNotification();
      getList();
    }
  };
  const handleChangeReadStatus = async (id, status) => {
    try {
      setIsLoading(true);
      const options = {
        id: id,
        status: status === "Y" ? "N" : "Y",
      };
      const res = await changeReadStatus(options);
      if (res?.status === true) {
        notification.open({
          message: "Success",
          description: `Read status changed successfully.`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />
          ),
          duration: 2,
        });
      }
    } catch (error) {
      setIsLoading(false);
      notification.open({
        message: "Oops!",
        description: `Something when wrong! Please try again.`,
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        duration: 2,
      });
      console.log("error : ", error);
    } finally {
      setIsLoading(false);
      getList();
    }
  };

  const handleChangeStatus = async (id, status) => {
    try {
      setIsLoading(true);
      const options = {
        id: id,
        status: status === "A" ? "I" : "A",
      };
      const res = await changeStatus(options);
      if (res?.status === true) {
        notification.open({
          message: "Success",
          description: `Status changed successfully.`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />
          ),
          duration: 2,
        });
      }
    } catch (error) {
      setIsLoading(false);
      notification.open({
        message: "Oops!",
        description: `Something when wrong! Please try again.`,
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        duration: 2,
      });
      console.log("error : ", error);
    } finally {
      setIsLoading(false);
      getList();
    }
  };
  const confirmDeleteNotification = (id) => {
    Modal.confirm({
      title: "Delete Notification",
      content:
        "Are you sure you want to delete this notification? This action cannot be undone.",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () => handleDeleteNotification(id),
    });
  };

  const handleDeleteNotification = async (id) => {
    try {
      setIsLoading(true);
      const options = {
        id: id,
      };
      const res = await deleteNotification(options);
      if (res?.status === true) {
        notification.open({
          message: "Success",
          description: `Notification deleted successfully.`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />
          ),
          duration: 2,
        });
      }
    } catch (error) {
      setIsLoading(false);
      notification.open({
        message: "Oops!",
        description: `Something when wrong! Please try again.`,
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        duration: 2,
      });
    } finally {
      setIsLoading(false);
      getList();
    }
  };

  const [detailsList, setDetailsList] = useState([]);
  const getDetailsList = async (id, viewType) => {
    try {
      if (id === "" || viewType === "") {
        return false;
      }
      setIsLoading(true);
      const options = {
        id: id,
        condition: {
          is_read: viewType === "read" ? "Y" : "N",
        },
      };
      const res = await details(options);
      if (res?.status === true) {
        setDetailsList(res?.result);
      } else {
        notification.open({
          message: "Oops!",
          description: `Something when wrong! Please try again.`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />
          ),
          duration: 2,
        });
      }
    } catch (error) {
      setIsLoading(false);
      console.log("error : ", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleCloseDetailsPopup = () => {
    setDetailsList([]);
    getList();
  }

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        'to'        : form.get('to_date') || '',
        'from'      : form.get('from_date') || '',
      }))
      // console.log('filter',filter);
      // alert('submit');
      handleFiterDrawer();
      setSkip(0);
    } catch (error) {
      
    }
  }

  const [helpText, setHelpText] = useState('');
  const handleSearchByChange = (e) => {
    try {
      const {value} = e.target;
      if(value === 'invoice_date'){
        setHelpText('Format should be YYYY-MM-DD. (e:g 2024-12-25)');
      } else if(value === 'payment_mode'){
        setHelpText('Enter Cash/Online only.');
      } else{
        setHelpText('');
      }
    } catch (error) {
      
    }
  }

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Notifications List"} />
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            {/* Add Notification Section*/}
            {showAddNotification && (
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <form onSubmit={handleSendNotification} ref={formRef}>
                  <div className="row">
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <button
                            type="button"
                            className="btn btn-info"
                            onClick={() => toggleAddNotification()}
                          >
                            <FontAwesomeIcon
                              icon={faXmark}
                              style={{ fontSize: 20, color: "#dc3545" }}
                            />
                          </button>
                        </div>
                      </div>
                    <div className="inventory_all_tabs">
                      <div className="form-group col-lg-2 col-md-2 col-sm-12 col-xs-12">
                        <select 
                          className="form-control store_input_field" 
                          name="userType"
                          value={userType}
                          onChange={handleUserTypeChange}
                        >
                          <option value={'Users'}>Users</option>
                          <option value={'Agent'}>Field Officer</option>
                          <option value={'Admin'}>Admin</option>
                        </select>
                      </div>
                      <div className="form-group col-lg-10 col-md-10 col-sm-12 col-xs-12">
                        {userType === "Users" && (
                          <UserSelectWithSearch
                            value={usersList}
                            onChange={setUsersList}
                            placeholder="Select Users"
                            className="form-control store_input_field"
                            style={{ width: "99%" }}
                            maxTagCount={3}
                          />
                        )} 
                        {userType === "Agent" && (
                          <AgentSelectWithSearch
                            value={usersList}
                            onChange={setUsersList}
                            placeholder="Select Field Officers"
                            className="form-control store_input_field"
                            style={{ width: "100%" }}
                            maxTagCount={3}
                          />
                        )}
                        {userType === "Admin" && (
                          <AdminSelectWithSearch
                            value={usersList}
                            onChange={setUsersList}
                            placeholder="Select Admins"
                            className="form-control store_input_field"
                            style={{ width: "100%" }}
                            maxTagCount={3}
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="inventory_all_tabs">
                      <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <input
                          type="text"
                          name="title"
                          id="title"
                          placeholder="Enter Title"
                          className="form-control store_input_field"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="inventory_all_tabs">
                      <div
                        className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12"
                        style={{ position: "relative" }}
                      >
                        <textarea
                          ref={messageRef}
                          name="message"
                          id="message"
                          placeholder="Enter Message"
                          className="form-control store_input_field"
                          rows="4"
                        />
                        <button
                          type="button"
                          onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                          style={{
                            position: "absolute",
                            right: "25px",
                            bottom: "15px",
                            background: "none",
                            border: "none",
                            fontSize: "20px",
                            cursor: "pointer",
                            padding: "5px",
                          }}
                          title="Add Emoji"
                        >
                          + 😊
                        </button>
                        {showEmojiPicker && (
                          <div
                            style={{
                              position: "absolute",
                              bottom: "60px",
                              right: "15px",
                              background: "white",
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                              padding: "10px",
                              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                              zIndex: 1000,
                              maxWidth: "300px",
                              maxHeight: "200px",
                              overflowY: "auto",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "5px",
                              }}
                            >
                              {emojis.map((emoji, index) => (
                                <span
                                  key={index}
                                  onClick={() => {
                                    handleEmojiClick(emoji);
                                    setShowEmojiPicker(false);
                                  }}
                                  style={{
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    padding: "5px",
                                    borderRadius: "4px",
                                    transition: "background 0.2s",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.target.style.background = "#f0f0f0")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.target.style.background = "transparent")
                                  }
                                >
                                  {emoji}
                                </span>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="inventory_all_tabs">
                      <div className="form-group col-lg-10 col-md-10 col-sm-12 col-xs-12"></div>

                      <div className="form-group col-lg-2 col-md-2 col-sm-6 col-xs-12">
                        <button
                          type="submit"
                          disabled={isLoading}
                          className="btn btn-danger"
                        >
                          Send Notification
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </Box>
            )}
            {/* End of Section */}
            {!showAddNotification &&
              (PERMISSION?.send === "Y" || PERMISSION?.fullAccess === "Y") && (
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <div className="inventory_all_tabs">
                    <div className="all_tabs_value"></div>
                    <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                      <div className="inventory_filter_div" onClick={handleFiterDrawer}>
                        <FontAwesomeIcon icon={faFilter} />
                        <Link
                          to={"javaScript:void(0)"}
                          className="filter_btn_invontry_rating_review"
                        >
                          Filters
                        </Link>
                      </div>
    
                      <div onClick={() => toggleAddNotification()}>
                        <button type="button" className="btn btn-danger">
                          <span className="request_new_categories">Send Notification</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </Box>
              )}
            {/* Notification List Section*/}
            {!showAddNotification && (
              <VendorList>
                <div>
                  <div id="content-wrapper" className="d-flex flex-column">
                    <div className="card shadow mb-4">
                      <div className="card-body pt-0">
                        <div className="table-responsive">
                          <table
                            className="table table-bordered"
                            id="dataTable"
                            width="100%"
                            cellspacing="0"
                          >
                            <thead>
                              <tr>
                                <th>Sl. No.</th>
                                <th>Title</th>
                                <th>Description</th>
                                {(PERMISSION?.details === "Y" || PERMISSION?.fullAccess === "Y") && (<>
                                  <th>Read</th>
                                  <th>Unread</th>
                                </>)}
                                  <th>Status</th>
                                <th>Created on</th>
                                {(PERMISSION?.fullAccess === "Y" ||
                                  PERMISSION?.send === "Y" ||
                                  PERMISSION?.change_read_status === "Y" ||
                                  PERMISSION?.change_status === "Y" ||
                                  PERMISSION?.delete === "Y") && (
                                  <th>Action</th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {ALLLISTDATA?.length > 0 ? (
                                ALLLISTDATA.map((items, index) => (
                                  <>
                                    <tr key={index}>
                                      <td>{SKIP + index + 1}</td>
                                      <td className="admin_user_list_date">
                                        {items?.title || "-"}
                                      </td>
                                      <td>{items?.description || "-"}</td>
                                      {(PERMISSION?.details === "Y" || PERMISSION?.fullAccess === "Y") && (<>
                                        <td>
                                          {`${items?.read_count}  `}
                                          <Link
                                            to={"javascript:void(0)"}
                                            onClick={() =>
                                              getDetailsList(items?._id, "read")
                                            }
                                          >
                                            <FontAwesomeIcon icon={faEye} />
                                          </Link>
                                        </td>
                                        <td>
                                          {`${
                                            items?.users_list?.length -
                                            items?.read_count
                                          }  `}
                                          <Link
                                            to={"javascript:void(0)"}
                                            onClick={() =>
                                              getDetailsList(items?._id, "unread")
                                            }
                                          >
                                            <FontAwesomeIcon icon={faEye} />
                                          </Link>
                                        </td>
                                      </>)}

                                      <td>{items?.status || "-"}</td>
                                      <td>
                                        {formatProjectDate(items?.createdAt)}
                                      </td>
                                      {(PERMISSION?.fullAccess === "Y" ||
                                        PERMISSION?.send === "Y" ||
                                        PERMISSION?.change_read_status ===
                                          "Y" ||
                                        PERMISSION?.change_status === "Y" ||
                                        PERMISSION?.delete === "Y") && (
                                        <td
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          {items?.status !== "D" ? (
                                            <Dropdown
                                              overlay={
                                                <Menu>
                                                  {(PERMISSION?.delete ===
                                                    "Y" ||
                                                    PERMISSION?.fullAccess ===
                                                      "Y") && (
                                                    <Menu.Item
                                                      key={`01`}
                                                      onClick={() =>
                                                        confirmDeleteNotification(
                                                          items?._id
                                                        )
                                                      }
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faTrash}
                                                      />{" "}
                                                      <span className="show_span">
                                                        Delete
                                                      </span>
                                                    </Menu.Item>
                                                  )}

                                                  {(PERMISSION?.change_read_status ===
                                                    "Y" ||
                                                    PERMISSION?.fullAccess ===
                                                      "Y") &&
                                                    items?.read_count === 0 &&
                                                    items?.status === "A" && (
                                                      <Menu.Item
                                                        key={`02`}
                                                        onClick={() =>
                                                          handleChangeReadStatus(
                                                            items?._id,
                                                            "N"
                                                          )
                                                        }
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faCheckDouble}
                                                        />{" "}
                                                        <span className="show_span">
                                                          Mark As Read
                                                        </span>
                                                      </Menu.Item>
                                                    )}

                                                  {(PERMISSION?.change_read_status ===
                                                    "Y" ||
                                                    PERMISSION?.fullAccess ===
                                                      "Y") &&
                                                    items?.read_count > 0 &&
                                                    items?.status === "A" && (
                                                      <Menu.Item
                                                        key={`03`}
                                                        onClick={() =>
                                                          handleChangeReadStatus(
                                                            items?._id,
                                                            "Y"
                                                          )
                                                        }
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faCheck}
                                                        />{" "}
                                                        <span className="show_span">
                                                          Mark As Unread
                                                        </span>
                                                      </Menu.Item>
                                                    )}

                                                  {(PERMISSION?.change_status ===
                                                    "Y" ||
                                                    PERMISSION?.fullAccess ===
                                                      "Y") &&
                                                    items?.status === "A" && (
                                                      <Menu.Item
                                                        key={`04`}
                                                        onClick={() =>
                                                          handleChangeStatus(
                                                            items?._id,
                                                            items?.status
                                                          )
                                                        }
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faThumbsDown}
                                                        />{" "}
                                                        <span className="show_span">
                                                          Inactive
                                                        </span>
                                                      </Menu.Item>
                                                    )}

                                                  {(PERMISSION?.change_status ===
                                                    "Y" ||
                                                    PERMISSION?.fullAccess ===
                                                      "Y") &&
                                                    items?.status === "I" && (
                                                      <Menu.Item
                                                        key={`05`}
                                                        onClick={() =>
                                                          handleChangeStatus(
                                                            items?._id,
                                                            items?.status
                                                          )
                                                        }
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faThumbsUp}
                                                        />{" "}
                                                        <span className="show_span">
                                                          Active
                                                        </span>
                                                      </Menu.Item>
                                                    )}
                                                </Menu>
                                              }
                                              placement="bottomLeft"
                                              arrow
                                            >
                                              <FontAwesomeIcon
                                                icon={faEllipsis}
                                              />
                                            </Dropdown>
                                          ) : (
                                            "--"
                                          )}
                                        </td>
                                      )}
                                    </tr>
                                  </>
                                ))
                              ) : isLoading ? (
                                <SkeltonList row={10} col={10} />
                              ) : (
                                <tr>
                                  <td colspan="9" className="img-center">
                                    No data found !
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                          <div className="table_pagination_sales_order">
                            <Pagination
                              count={TOTALPAGES}
                              onChange={handlePageChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </VendorList>
            )}
          </Box>
        </div>
      </div>

      {/* Export*/}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'red', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="filter_by" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" onChange={handleSearchByChange} id="filter_by" ref={inputRef1}>
                  <option value=''>Select search field</option>
                  <option value='title' selected={filter?.filter_by ==='title'?true:false}>Title</option>
                  <option value='description' selected={filter?.filter_by ==='description'?true:false}>Description</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="search" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                />
                {helpText?<label style={{color:'blue'}}>{helpText}</label>:''}
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  From :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="from_date"
                  className="form-control store_input_field"
                  id="from_date"      
                  ref={inputRef3}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  To :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="to_date"
                  className="form-control store_input_field"
                  id="to_date"   
                  ref={inputRef4}
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "black", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
      <NotificationDetails
        popUpOpen={detailsList?.length > 0 ? true : false}
        detailsList={detailsList}
        setDetailsList={handleCloseDetailsPopup}
      />
      <LoadingEffect isLoading={isLoading} text="Loading..." />
    </>
  );
}
